import { render } from "./ChartIcon.vue?vue&type=template&id=eeb96504"
const script = {}

import exportComponent from "C:\\Users\\Henrik Bergmann\\Documents\\App-Unvergessen-Agency\\app-unvergessen-agency\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__